import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { account } from "../api/endpoints";

export default function TokenBalance() {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  useEffect(() => {
    account.tokens().then((r) => setData(r.data)).catch(() => setData(null));
  }, []);

  if (!data) {
    return <div className="text-xs text-slate-500">{t("nav.loadingBalance")}</div>;
  }

  return (
    <Link
      to="/dashboard/billing"
      className="block rounded-lg bg-brand-100 p-3 hover:bg-brand-200 transition"
    >
      <div className="text-xs text-slate-600">{t("nav.tokenBalance")}</div>
      <div className="mono text-2xl font-bold text-brand-800">
        {data.token_balance}
      </div>
      <div className="text-xs text-slate-500">
        {t("nav.scansLeft", { count: data.estimated_scans_remaining })}
      </div>
    </Link>
  );
}
